export const MODE_COLUMN_ID = 'Mode';

export const FAULTED = 'faulted';
export const ESTOPPED = 'estop';

export const DISABLED_TOOLTIP_MAP: Record<string, string> = {
  [FAULTED]: 'This device is faulted and cannot be edited',
  [ESTOPPED]: 'This device is e-stopped and cannot be edited',
};
